// src/componentes/tienda/tiendaPublica/LogoTienda.js
// Logo de la tienda sin marco: el logo se guarda con un margen (transparente o
// blanco) para avatares y tickets; aquí se recorta para que llene su espacio.
// Mientras se recorta (o si el navegador no puede), se ve el original.
import React, { useEffect, useState } from 'react';
import { recortarMargenLogo } from '../../../utilidades/logoGym';

export const LogoTienda = ({ logo }) => {
  const [recortado, setRecortado] = useState(null);
  useEffect(() => {
    let vigente = true;
    setRecortado(null);
    recortarMargenLogo(logo).then((url) => { if (vigente) setRecortado(url); });
    return () => { vigente = false; };
  }, [logo]);
  return <img src={recortado || logo} alt="" />;
};
